import ManualForm from "./form";

export default ManualForm;
